import * as ACTIONS from 'constants/actions';
import { API_URL, HTTP_HEADERS } from 'constants/apis';
import config from 'config';
import { UserManager } from 'paycor-oidc-client';

const { ACCOUNTS } = API_URL;
const AccountUri = `${config.HOST.AUTHENTICATION_URL}${ACCOUNTS}`;

export const redirectOnUnauthenticated = () => {
	const _return = encodeURIComponent(window.location.href);
	const redirect = `${AccountUri}/Authentication/Signin?ReturnUrl=${_return}`;
	return (window.location.href = redirect);
};

export const redirectToLogout = () => {
	const logout = `${AccountUri}/Authentication/Logout`;
	return (window.location.href = logout);
};

export const refreshSession = () => {
	return fetch(`${AccountUri}/`, HTTP_HEADERS().GET);
};

export const clearUser = (dispatch) => {
	let manager = new UserManager(config.SECURITYSETTINGS);
	manager.removeUser().then(() => {
		dispatch({
			type: ACTIONS.LOGGED_IN_USER_LOADED,
			payload: null
		});
	});
};

export const onAuthFailed = (e) => {
	console.error('Authentication Failed:', e);
	redirectOnUnauthenticated();
};

export const onAuthError = (e) => {
	console.error('Authentication Error occurred:', e);
	redirectOnUnauthenticated();
};
